/**
 * The footer shown below the current page's content.
 */

import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import React from 'react';


export const Footer = () => {

    return (
        <Column alignmentHorizontal="center" backgroundColor="subdued" spacingInset="400 500">
            <Row alignmentHorizontal="justify" width="90%" maxWidth="100%">
                <Text>Confidential, for Amazon use only.</Text>
            </Row>
        </Column>
    );
};
